import { autofill } from "@mapbox/search-js-web";

export default ({ accessToken, options, init, destroy, ...props }) => {
    let instance = null;

    return {
        ...props,
        getAutofill() {
            return instance;
        },
        initAutofill(opts) {
            if (instance) {
                instance.remove();
            }

            instance = autofill({
                accessToken,
                options: {
                    ...options,
                    ...opts,
                },
            });

            /**
             * To ensure compatibility with Stripe Address validation
             * address_level1 / state must be in ISO 3166-2 format
             */
            instance.addEventListener("retrieve", (event) => {
                event.detail.features.forEach((feature) => {
                    if (["us", "ca"].includes(feature.properties.country_code)) {
                        feature.properties.address_level1 =
                            feature.properties.region_code ?? feature.properties.address_level1;
                    }
                });
            });
        },
        removeAutofill() {
            instance.remove();
            instance = null;
        },
        init() {
            this.initAutofill();

            init?.bind(this)();
        },
        destroy() {
            this.removeAutofill();

            destroy?.bind(this)();
        },
    };
};
